﻿/**
 * app.run
 * @namespace portal
 */

(function () {
	'use strict';

	/** initialize the nha.portal module */
	angular.module('nha.portal').run(run);

	/** injection */
	run.$inject = ['$location', '$rootScope', 'stateTransitionSecurityCheck', 'userContextService', 'appSettings'];

	/** implementation */
    function run($location, $rootScope, stateTransitionSecurityCheck, userContextService, appSettings) {

		userContextService.ensureUserContext().then(function (user) {
			var myNHA = window['myNHA'];
			var tagManager = new myNHA.TagManagerService();
			tagManager.setupUserID();
		});

		/** add security check on state change */
		stateTransitionSecurityCheck.attachStateChangeListener('portal.403');

		/** change page title */
		var pageTitleAppName = ' | NHA Portal';
		var defaultPageTitle = 'Home' + pageTitleAppName;

		/** whenever the UI Route changes, fire off this event to update the page title */
		$rootScope.$on('$stateChangeSuccess', function (event, toState) {
			if (toState.hasOwnProperty('title')) document.title = toState.title + pageTitleAppName;
			else if (document.title !== defaultPageTitle) document.title = defaultPageTitle;
		});
	}
})();